import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { DisableHardwareEntrypointProps } from './DisableHardware.entrypoint.types.tsx';

type DisableHardwareEntryPointComponent = EntryPointComponent<
	{},
	{},
	DisableHardwareEntrypointProps,
	{}
>;

export const disableHardwareEntryPoint: EntryPoint<DisableHardwareEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<DisableHardwareEntryPointComponent>(
			/* webpackChunkName: "async-itam-settings-disable-hardware" */ './DisableHardware.tsx',
		),
		getPreloadProps: () => ({
			extraProps: {},
		}),
	});
